import {immerable} from "immer";
import {PackValidationDto} from "../../../../../models/interfaces/dtos/pack-validation-dto.ts";
import IdItem from "../../../../../models/interfaces/generics/id-item.ts";
import ValidationState from "../../../../../models/enums/validation-state.ts";

class ValidationElement implements IdItem {
    [immerable] = true;
    
    id: string;
    
    state: ValidationState;
    
    constructor(packValidationDto: PackValidationDto) {
        this.id = packValidationDto.validationId;
        this.state = packValidationDto.validationState;
    }
}

export default ValidationElement;